import { cacheMutations } from './cache'

export default {
  ...cacheMutations,
}
